import React, { } from "react";
import { IBasicControlPublicProps, IRuntimeControlProps } from "./types";
// import CompositeControl from "./CompositeControl.tsx.old";
import { BasicInputControl, CheckOrRadio, RadioGroup } from "./BasicControls";
import OptionSetControl from './OptionSetControl';
import FileControl from "./FileControl";
import DateRangeControl from "./DateRangeControl";
import NumberControl from "./NumberControl";
import DateControl from "./DateControl";
import MultiOptionControl from "./MultiOptionControl";

const DynamicControl: React.FunctionComponent<IBasicControlPublicProps<any, any> & IRuntimeControlProps> = (props) => {
    let Control: React.ComponentType<IBasicControlPublicProps<any, any> & IRuntimeControlProps>;

    switch (props.definition.type) {
        // case 'composite':
        //     return <CompositeControl formId={formId}  config={control.config} />

        default:
            return <div>Control '{props.definition.key}' type '{props.definition.type}' is not supported</div>;

        case 'basic':
            Control = BasicInputControl;
            break;
        case 'basicbox':
            Control = CheckOrRadio;
            break;
        case 'date':
            Control = DateControl;
            break;
        case 'date-range':
            Control = DateRangeControl;
            break;
        case 'file':
            Control = FileControl;
            break;
        case 'group':
            Control = RadioGroup;
            break;
        case 'number':
            Control = NumberControl;
            break;
        case 'optionset':
            Control = OptionSetControl;
            break;
        case 'multioption':
            Control = MultiOptionControl;
            break;
    }

    return <Control {...props} />;
};

export default DynamicControl;